import { Shield, GraduationCap } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/hooks/useLanguage";
import { immigrationContent } from "@/i18n/immigration-content";

const DACA = () => {
  const { language } = useLanguage();
  const content = immigrationContent.daca[language];

  const faqs = content.faq || [
    {
      question: "Can I travel outside the U.S. with DACA?",
      answer: "DACA recipients cannot travel internationally without advance parole. We can help you apply for advance parole for humanitarian, educational, or employment purposes. Traveling without advance parole will terminate your DACA and make you inadmissible.",
    },
    {
      question: "How often must I renew DACA?",
      answer: "DACA must be renewed every two years. We recommend filing renewal applications 120-150 days before expiration. Don't wait until the last minute - processing delays can leave you without work authorization if your DACA expires.",
    },
  ];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        <h2 className="text-3xl font-bold mb-6">{content.sections[0].title}</h2>
        <p className="text-xl text-muted-foreground mb-8">
          {content.sections[0].content}
        </p>

        <h3 className="text-2xl font-bold mb-4">DACA Eligibility</h3>
        <ul className="list-disc pl-6 mb-6">
          <li>Arrived in the U.S. before age 16</li>
          <li>Continuously resided here since June 15, 2007</li>
          <li>Were under 31 as of June 15, 2012</li>
          <li>Currently in school or have graduated or obtained a GED</li>
          <li>Have no serious criminal history</li>
        </ul>

        <h3 className="text-2xl font-bold mb-4">Our DACA Services</h3>
        <ul className="list-disc pl-6 mb-8">
          <li>Initial DACA applications for eligible first-time applicants</li>
          <li>DACA renewals (file 120-150 days before expiration)</li>
          <li>Advance parole applications for international travel</li>
          <li>Employment authorization documents (EAD)</li>
          <li>Addressing RFEs or denials</li>
        </ul>

        <h3 className="text-2xl font-bold mb-6">Frequently Asked Questions</h3>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title={content.title}
      subtitle={content.subtitle}
      icon={<GraduationCap className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default DACA;